import { render, staticRenderFns } from "./FooterStyle1.vue?vue&type=template&id=44f84170&"
import script from "./FooterStyle1.vue?vue&type=script&lang=js&"
export * from "./FooterStyle1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports